var map = {
	"./Home-96.png": 1315,
	"./Hotels-96.png": 1316,
	"./Invoice-96.png": 1317,
	"./Office-Phone-96.png": 1318,
	"./Quotation-96.png": 1319,
	"./admins.png": 1320,
	"./articles.png": 367,
	"./attributes.png": 575,
	"./bills.png": 1321,
	"./bookings.png": 1322,
	"./calendar.png": 1323,
	"./chat.png": 1324,
	"./customer-affiliates.png": 1325,
	"./customer-buyers.png": 1326,
	"./customer-sellers.png": 1327,
	"./customers.png": 1328,
	"./field-latex-sell-on-cash.png": 1329,
	"./latex-sales-2.png": 1330,
	"./noteSettings.png": 1331,
	"./places.png": 1332,
	"./products.png": 1333,
	"./purchases-2.png": 1334,
	"./purchases.png": 1335,
	"./reports.png": 1336,
	"./rubber-debtors.png": 1337,
	"./rubber-payments.png": 1338,
	"./rubber-products.png": 1339,
	"./rubber-receipt.png": 770,
	"./rubber-receivables.png": 576,
	"./rubber-reports.png": 577,
	"./rubber-sales-2.png": 1340,
	"./rubber-sales.png": 1341,
	"./rubber-sheet-contract.png": 771,
	"./rubber-sheet-deposit.png": 772,
	"./rubber-sheet-make.png": 1342,
	"./rubber-sheet-sell-on-cash.png": 1343,
	"./rubber-sheet-stock.png": 578,
	"./rubber-sheet.png": 1344,
	"./sales-notes.png": 1345,
	"./sales.png": 1346,
	"./sell-online.png": 569,
	"./services.png": 1347,
	"./settings.png": 1348,
	"./sites.png": 1349,
	"./tasks.png": 1350,
	"./tours.png": 1351,
	"./tours2.png": 1352,
	"./users.png": 1353,
	"./vouchers.png": 574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 769;